
import * as angular from "angular";

export interface IClickOutDirectiveScope extends angular.IScope {

    clickOut: () => void;
}

export class ClickOutDirective implements angular.IDirective {

    restrict = "A";

    link: ($scope: IClickOutDirectiveScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => void;

    constructor($timeout: angular.ITimeoutService, $document: angular.IDocumentService) {

        ClickOutDirective.prototype.link = ($scope: IClickOutDirectiveScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {

            const onClick = (event: JQueryEventObject) => {
                const isChild = $element[0].contains(event.target);
                const isSelf = $element[0] === event.target;
                const isInside = isChild || isSelf;

                let isIgnored = false; // clickout shouldn't be ignored unless...
                if (attrs.clickOutIgnoreClasses) {
                    isIgnored = ClickOutDirective.shouldIgnoreElement(
                        event.target,
                        attrs.clickOutIgnoreClasses.split(' ').map(classNameStr => classNameStr.trim())
                    );
                }

                const doClickOut = !isInside && !isIgnored;

                if (doClickOut && attrs.clickOut) {
                    $scope.$eval(attrs.clickOut)

                    $scope.$applyAsync();
                }

                event.stopPropagation();
                event.cancelBubble = true;
            }

            $timeout(() => {
                $document.bind("click", onClick);
            }, 500);

            $scope.$on("$destroy", () => {
                $document.unbind("click", onClick);
            });
        }
    }

    // decides whether click out should be ignored for passed element
    static shouldIgnoreElement(element: Element, classesToIgnore: string[]): boolean {
        ClickOutDirective.shouldIgnoreElement["parentCounter"] = ClickOutDirective.shouldIgnoreElement["parentCounter"] ?? 0
        ClickOutDirective.shouldIgnoreElement["parentCounter"]++

        // we don't want to go too high up the parents tree
        // when the limit is exceeded, the timer gets reset and element considered to trigger a click out
        if (ClickOutDirective.shouldIgnoreElement["parentCounter"] > 20) {
            ClickOutDirective.shouldIgnoreElement["parentCounter"] = 0;

            return false;
        }

        // this is recursive to increase chances of finding the element to ignore
        return  classesToIgnore.some(item => element?.classList?.contains(item)) ||
                !!element.parentElement && ClickOutDirective.shouldIgnoreElement(element.parentElement, classesToIgnore);
    };

    // ----------------

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService, $document: angular.IDocumentService) => new ClickOutDirective($timeout, $document);

        directive.$inject = ["$timeout", "$document"];

        return directive;
    }
}
